import type { Currency } from '@/scopes/common/domain/types';

export function pricePerPersonFilterRangeValues(currency: Currency) {
  if (currency === 'SEK' || currency === 'DKK') {
    return {
      minValue: 1000,
      maxValue: 15000,
      step: 500,
      maxPossibleValue: 15100,
    };
  }

  return {
    minValue: 0,
    maxValue: 2000,
    maxPossibleValue: 2100,
    step: 100,
  };
}
